
import favicons from '~/mixins/favicons';
import GwHeader from '~/patterns/organisms/header/header.vue';

export default {
    components: {
        GwHeader,
    },
    mixins: [favicons],
    head() {
        return {
            meta: [
                ...this.faviconMeta
            ],
            link: [
                ...this.faviconLink
            ]
        };
    },
};
